<template>
  <div class="flex">
    <div :class="[heightClass, widthClasses[0]]" class="bg-ba-secondary"></div>
    <div :class="[heightClass, widthClasses[1]]" class="bg-ba-primary"></div>
    <div :class="[heightClass, widthClasses[2]]" class="bg-ba-tertiary"></div>
  </div>
</template>
<script lang="ts" setup>
withDefaults(
  defineProps<{
    heightClass?: string
    widthClasses?: string[]
  }>(),
  {
    heightClass: 'h-6px',
    widthClasses: () => ['w-[calc(100%-40px)]', 'w-[20px]', 'w-[20px]'],
  }
)
</script>
